import React, { useState, useContext, useEffect } from 'react';
import { useParams, Link } from "react-router-dom";
import Alerta from "../modal/Alerta";
import AuthContext from '../../context/authentication/authContext';
import loader from "../../img/ajax-loader.gif";

const ResetPassword = () => {

    //  Extraer valores de context
    const authContext = useContext(AuthContext);
    const { msg, authenticated, reiniciarPassword } = authContext;

    useEffect(() => {
        if ( msg ) {
            setMessage(msg.msg);
        }
        // eslint-disable-next-line
    }, [msg, authenticated ]);

    //  Extraer Profile
    const { hash } = useParams();

    const [ user, setUser ] = useState({
        recovery_hash: hash,
        password: '',
        confirm_password: ''
    });

    // eslint-disable-next-line
    const { recovery_hash, password, confirm_password } = user;

    const [ showAlerta, setShowAlerta] = useState(false);
    const [ message, setMessage ] = useState("");

    const onChange = e => {
        setUser({
            ...user,
            [e.target.name]: e.target.value
        })
    }

    const onSubmit = e => {
        e.preventDefault();

        // Passwords Iguales
        if ( password !== confirm_password ) {
            setMessage("No coinciden las contraseñas introducidas");
            setShowAlerta(true);
            document.getElementById("confirm_password").focus()
            return;
        }

        setMessage(<label><img src={loader} alt="loader" /> Procesando...</label>);
        setShowAlerta(true);

        reiniciarPassword(user).then(setShowAlerta(true));
    }

    return (
        <div className="global-container">
            { showAlerta && <Alerta isOpen={showAlerta} onClose={() => setShowAlerta(false)} infoMsg={message} /> }
            <div className="login-form">
                <div className="card">
                    <div className="card-body">
                        <h3 className="card-title text-center">Reiniciar Contraseña</h3>
                        <div className="card-text">
                            <form onSubmit={onSubmit}>
                                <div className="form-group">
                                    <label htmlFor="password">Contraseña</label>
                                    <div className="form-group">
                                        <input
                                            type="password"
                                            id="password"
                                            name="password"
                                            title="Contraseña"
                                            placeholder="Contraseña"
                                            className="form-control form-control-sm"
                                            value={password}
                                            onChange={onChange}
                                            required
                                            minLength="6" />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="confirm_password">Confirme la contraseña</label>
                                    <div className="form-group">
                                        <input
                                            type="password"
                                            id="confirm_password"
                                            name="confirm_password"
                                            title="Confirme la contraseña"
                                            placeholder="Confirme la contraseña"
                                            className="form-control form-control-sm"
                                            value={confirm_password}
                                            onChange={onChange}
                                            required
                                            minLength="6" />
                                    </div>
                                </div>

                                <button type="submit" className="btn btn-primary btn-block">Reestablecer</button>
                                <div className="sign-up">
                                    <Link to={'/'} className="enlace-cuenta">
                                        Iniciar sesión
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ResetPassword